// A thread is a follow-up once it holds more than the initial user+ai turns.
export const isFollowUpFromConversations = (conversations) => (conversations?.length ?? 0) > 2;

const NOTE_FLAG = /\[note (start|end)\]/gi;
// A trailing prefix of an unfinished marker still mid-stream
const NOTE_FLAG_PARTIAL =
  /\[(?:n(?:o(?:t(?:e(?: (?:s(?:t(?:a(?:r(?:t)?)?)?)?|e(?:n(?:d)?)?)?)?)?)?)?)?$/i;

export const stripNoteFlags = (text) =>
  typeof text === 'string' ? text.replace(NOTE_FLAG, '').replace(NOTE_FLAG_PARTIAL, '') : text;

export const updatePromptList = (
  prevPrompts,
  intelligence_chat_id,
  intelligenceChat,
  isDescription = false
) => {
  if (prevPrompts?.[0]?.id === intelligence_chat_id) {
    if (isDescription) {
      const nextPrompts = [...prevPrompts];
      nextPrompts[0] = {
        ...prevPrompts[0],
        id: intelligence_chat_id,
        name: intelligenceChat?.name || 'New Note',
        description: intelligenceChat?.description || '',
        noteType: intelligenceChat?.noteType,
        template_id: intelligenceChat?.template_id ?? prevPrompts[0]?.template_id ?? null,
        created_at: intelligenceChat?.created_at ?? prevPrompts[0]?.created_at
      };
      return nextPrompts;
    }
    return prevPrompts;
  }
  const newPrompt = {
    id: intelligence_chat_id,
    name: 'New Note',
    description: intelligenceChat?.description || '',
    noteType: intelligenceChat?.noteType,
    template_id: intelligenceChat?.template_id ?? null,
    created_at: intelligenceChat?.created_at
  };
  return [newPrompt, ...prevPrompts];
};
